if (!customElements.get("ona-tabs")) {
  customElements.define(
    "ona-tabs",
    class Slider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.elements = {
          tabs: this.querySelectorAll(".tabs__tab-button"),
          panels: this.querySelectorAll(".tabs__panel")
        };
        this._selectTab = this._selectTab.bind(this);
        this.elements.tabs.forEach((tab, index) => {
          tab.addEventListener("click", () => {
            this._selectTab(index);
          });
        });
        this._selectTab(0);
      }
      _selectTab(index) {
        this.elements.tabs.forEach((tab, i) => {
          tab.setAttribute("aria-selected", i === index);
        });
        this.elements.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
      }
    }
  );
}
